// src/constants/loyalty.ts - Version avec configuration business

import { Business, getLoyaltyConfiguration, isLoyaltyEnabled } from '../types/business';

/**
 * Pourcentage de bonus de fidélité accordé aux clients enregistrés (DEPRECATED)
 * Utiliser maintenant business.configuration.loyalty.bonusPercentage
 */
export const LOYALTY_PERCENTAGE = 3;

/**
 * Seuil minimum d'utilisation de la cagnotte (DEPRECATED)
 * Utiliser maintenant business.configuration.loyalty.minimumUsage
 */
export const LOYALTY_USAGE_MINIMUM = 1000;

/**
 * Calcule le bonus de fidélité pour une prestation selon la configuration du business
 * @param price Prix de la prestation
 * @param business Business pour récupérer la configuration
 * @returns Montant du bonus en FCFA (arrondi) - Retourne 0 si la cagnotte est désactivée
 */
export const calculateLoyaltyBonus = (price: number, business: Business | null = null): number => {
  // ✅ NOUVEAU : Vérifier si la cagnotte est activée
  if (!isLoyaltyEnabled(business)) {
    return 0;
  }
  
  const loyaltyConfig = getLoyaltyConfiguration(business);
  return Math.round(price * loyaltyConfig.bonusPercentage / 100);
};

/**
 * Récupère le seuil minimum d'utilisation de cagnotte pour un business
 * @param business Business pour récupérer la configuration
 * @returns Montant minimum en FCFA
 */
export const getLoyaltyUsageMinimum = (business: Business | null = null): number => {
  const loyaltyConfig = getLoyaltyConfiguration(business);
  return loyaltyConfig.minimumUsage;
};

/**
 * Vérifie si un montant de cagnotte peut être utilisé selon les règles du business
 * @param loyaltyAmount Montant de cagnotte à utiliser
 * @param business Business pour récupérer la configuration
 * @returns true si utilisable, false sinon (retourne false si la cagnotte est désactivée)
 */
export const canUseLoyaltyAmount = (loyaltyAmount: number, business: Business | null = null): boolean => {
  // ✅ NOUVEAU : Vérifier si la cagnotte est activée
  if (!isLoyaltyEnabled(business)) {
    return false;
  }
  
  const minimum = getLoyaltyUsageMinimum(business);
  return loyaltyAmount >= minimum;
};